// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";

const metadata: BuiltInScriptMetadata = {
  name: "Homing Duo",
  id: "homing-duo",
  metadata: {
    imports: ["sensor","projectile","spark","wait","speed"],
    icon: {
      "backgroundColor": 1644589,
      "layers": [
        {
          "iconKey": "lightning",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": 9,
          "color": 16774162
        },
        {
          "iconKey": "fireball",
          "position": {
            "x": 16,
            "y": 2
          },
          "scale": 0.64,
          "rotation": 0,
          "color": 3924985
        },
        {
          "iconKey": "delay",
          "position": {
            "x": -16,
            "y": 2
          },
          "scale": 0.61,
          "rotation": -11,
          "color": 16054501
        }
      ]
    },
  },
};

export default metadata;
